import { Injectable } from "@angular/core";
import { IPreference, IPreferenceUser } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class PreferenceApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Preferences", // Theme !
      [], // Post route paths
      [], // Get route paths
      [], // Update route paths
      [] // Delete route paths
    );
  }

  public list(context: string): Observable<any> {
    return this.api.get(`preferences/${context}`);
  }

  public update(preference: IPreference): Observable<IPreferenceUser> {
    return this.api.put("preference", preference) as Observable<IPreferenceUser>;
  }
}
